import { render, staticRenderFns } from "./immersive-digital.vue?vue&type=template&id=058e5473&scoped=true&"
import script from "./immersive-digital.vue?vue&type=script&lang=js&"
export * from "./immersive-digital.vue?vue&type=script&lang=js&"
import style0 from "./immersive-digital.vue?vue&type=style&index=0&id=058e5473&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058e5473",
  null
  
)

export default component.exports